import { isBackendError } from "./errors";

export interface ErrorPresentation {
  title: string;
  message: string;
  actionLabel: string;
}

export function presentError(error: unknown, context: "load" | "save" | "delete" | "action" = "action"): ErrorPresentation {
  const message = error instanceof Error ? error.message : "";
  const code = isBackendError(error) ? error.code : /offline|network|fetch/i.test(message) ? "offline" : /conflict|version/i.test(message) ? "conflict" : /not.?found/i.test(message) ? "not_found" : "unknown";
  if (code === "offline") return { title: "You are offline", message: `${context === "save" ? "Your edits remain on this page. " : "Nothing has changed. "}Reconnect and try again.`, actionLabel: "Try Again" };
  if (code === "conflict") return { title: "This content changed elsewhere", message: "Refresh the latest version, then decide whether to apply your changes again.", actionLabel: "Refresh" };
  if (code === "not_found") return { title: "This content no longer exists", message: "It may have been deleted elsewhere. Return to the list to see current content.", actionLabel: "Back to List" };
  if (isBackendError(error) && error.code === "validation") return { title: "Changes not saved", message: `${error.message} Update the value and save again.`, actionLabel: "Continue Editing" };
  return { title: context === "load" ? "Unable to load content" : context === "delete" ? "Delete not completed" : context === "save" ? "Changes not saved" : "Action not completed", message: message || "Try again later. Current content is unchanged.", actionLabel: "Retry" };
}

export function errorText(error: unknown, context: "load" | "save" | "delete" | "action" = "action") {
  const value = presentError(error, context);
  return `${value.title}：${value.message}`;
}
